import { createFileRoute } from '@tanstack/react-router'

import { ProviderPage } from '#/modules/intake/provider-page'

export const Route = createFileRoute('/_shell/providers/$providerId')({
  component: function ProviderRoute() {
    const { providerId } = Route.useParams()
    return <ProviderPage providerId={providerId} />
  },
})
